var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("服务中心")]),
              _c("el-breadcrumb-item", [_vm._v("语音服务")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.idcpName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "idcpName", $$v)
                                  },
                                  expression: "searchForm.idcpName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: Object.values(item)[0],
                                    value: Object.values(item)[0]
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工作工单" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工作工单" },
                              model: {
                                value: _vm.searchForm.ticketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticketId", $$v)
                                },
                                expression: "searchForm.ticketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "被叫电话" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入电话" },
                              model: {
                                value: _vm.searchForm.callee,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "callee", $$v)
                                },
                                expression: "searchForm.callee"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "呼叫状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", clearable: "" },
                                model: {
                                  value: _vm.searchForm.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "state", $$v)
                                  },
                                  expression: "searchForm.state"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "接通", value: "0" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "未接通", value: "1" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "拨打时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.createTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "createTime", $$v)
                                },
                                expression: "searchForm.createTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("语音服务列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c("div", { staticClass: "button-container" }, [
              _c("div", { staticClass: "button-left" }, [
                _vm._v(
                  "查询时间对应总费用：" +
                    _vm._s(_vm.all_fee) +
                    "元 --- 接通率：" +
                    _vm._s(_vm.accept_rate) +
                    "%"
                )
              ]),
              _c(
                "div",
                { staticClass: "button-right" },
                [
                  _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                    _vm._v("表头设置")
                  ])
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              _vm._l(_vm.visibleColumns, function(column, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    prop: column.prop,
                    label: column.label,
                    width: column.width,
                    align: "center",
                    fixed: column.fixed
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            column.prop === "reCallStatus"
                              ? _c("span", [
                                  scope.row.reCallStatus === "1"
                                    ? _c("span", [_vm._v("已重播")])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.reCallStatus || "-")
                                        )
                                      ])
                                ])
                              : column.prop === "state"
                              ? _c("span", [
                                  scope.row.state === "0"
                                    ? _c("i", {
                                        staticClass: "el-icon-phone-outline",
                                        staticStyle: {
                                          color: "green",
                                          "font-size": "40px"
                                        }
                                      })
                                    : scope.row.state === "1"
                                    ? _c("i", {
                                        staticClass: "el-icon-phone",
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "40px"
                                        }
                                      })
                                    : column.prop === "createTime"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row[column.prop]
                                              ? _vm
                                                  .$moment(
                                                    scope.row[column.prop]
                                                  )
                                                  .format("YYYY-MM-DD HH:mm:ss")
                                              : "-"
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(_vm._s(scope.row.state || "-"))
                                      ])
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[column.prop] || "-"))
                                ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }